module.exports = __webpack_public_path__ + "static/media/receta-12.5e93b184.png";